module.exports = __webpack_public_path__ + "images/34ed4f9d141a3d497e5783c51ec9f668-IMG_4485.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_4485.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_4485.jpg
// module chunks = 0